import React from 'react';
export function HowItWorks() {
  const steps = [{
    num: '01',
    title: 'Descarga',
    desc: 'Realizas el ejercicio de 3 minutos en la Guía PDF para liberar la tensión inmediata.'
  }, {
    num: '02',
    title: 'Escucha',
    desc: 'Inicias el audio de Protocolo de Acero mientras te preparas para dormir.'
  }, {
    num: '03',
    title: 'Consolida',
    desc: 'Tu cerebro archiva la información crítica automáticamente mientras disfrutas de un sueño reparador.'
  }];
  return <section className="py-16 md:py-24 bg-navy-800/30 border-y border-steel-400/5" data-id="element-82">
      <div className="container mx-auto px-4" data-id="element-83">
        <div className="max-w-4xl mx-auto" data-id="element-84">
          <h2 className="text-3xl md:text-4xl text-center mb-16" data-id="element-85">
            Cómo funciona en 3 pasos
          </h2>

          <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-86">
            {/* Connecting line for desktop */}
            <div className="hidden md:block absolute top-12 left-1/6 right-1/6 h-px bg-gradient-to-r from-transparent via-amber-500/30 to-transparent z-0" data-id="element-87"></div>

            {steps.map((step, index) => <div key={index} className="relative z-10 flex flex-col items-center text-center" data-id="element-88">
                <div className="w-24 h-24 rounded-full bg-navy-900 border-2 border-amber-500/30 flex items-center justify-center mb-6 shadow-[0_0_20px_rgba(201,148,62,0.1)]" data-id="element-89">
                  <span className="font-serif text-3xl text-amber-400" data-id="element-90">
                    {step.num}
                  </span>
                </div>
                <h3 className="text-xl font-medium text-white mb-3" data-id="element-91">
                  {step.title}
                </h3>
                <p className="text-steel-400 leading-relaxed" data-id="element-92">{step.desc}</p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}